<template>
  <pt-all-customer class="pt-all-customer__withData" :all-citys="allCitys" :sourceList="sourceList" :exportLoading="exportLoading" :branchCompanys="branchCompanys"  @exportAllCustomer="exportAllCustomer" :AllMallUser="AllMallUser"></pt-all-customer>
</template>

<script>
import PtAllCustomer from './index'
export default {
  name: 'pt-all-customer__withData',
  components: {
    'pt-all-customer': PtAllCustomer
  },
  data () {
    return {
      allCitys: [],
      sourceList: [],
      exportLoading: false,
      AllMallUser: 0,
      branchCompanys: []
    }
  },
  methods: {
    exportAllCustomer (val) {
      let data = {
        ...val,
        pageable: {}
      }
      this.exportLoading = true
      this.$store.dispatch('exportCustomerList', data).then(res => {
        this.exportLoading = false
        // dataExport(res)
        this.$message.success('数据准备中，完成导出后我们会将数据保存在“导出历史”中，您稍后下载即可')
      }).catch(err => {
        this.exportLoading = false
        this.$message.error(err || '导出用户失败')
      })
    },
    getAllCity () {
      this.$store.dispatch('getAllCity').then(res => {
        this.allCitys = res
      }).catch(err => {
        this.$message.error(err || '获取地区列表失败')
      })
    },
    getAllMallUser () {
      this.$store.dispatch('getAllMallUser').then(res => {
        this.AllMallUser = res
      }).catch(err => {
        this.$message.error(err || '获取全部用户列表失败')
      })
    },
    businessSource () {
      this.$store.dispatch('businessSource').then(res => {
        this.sourceList = res
      }).catch(err => {
        this.$message.error(err || '获取业务来源枚举失败')
      })
    },
    getBranchCompanyList () {
      let data = {
        pageableParam: {
          unpaged: true
        },
        type: 'BRANCH'
      }
      this.$store.dispatch('getBranchCompanyList', data).then(res => {
        this.branchCompanys = res.data
      }).catch(err => {
        this.$message.error(err || '获取分/子公司失败')
      })
    }
  },
  created () {
    this.getAllCity()
    this.businessSource()
    this.getAllMallUser()
    this.getBranchCompanyList()
  }
}
</script>
